import { asyncRoute } from '../../router';

export default asyncRoute(() =>
  import(/* webpackChunkName: "StaticPageContainer" */ './container/StaticPageContainer')
);
